module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAATCAYAAABlcqYFAAAACXBIWXMAAAsSAAALEgHS3X78AAAAYUlEQVQ4jWNklLVyYKAt+MDCwMCwn4lVmCa2/P//m+H/n08HQJYwsPCbYyigiiW/3zH8/niCgQlDhgZg1JJRS0YtGbVk1BIcAFzUg4pkWoB/fz6BjQVZcgBU5tMMMDBcAAC/rBkzMJWxyAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blue/shapes/rect-blue-b-1.png
// module id = 252
// module chunks = 0